import React, { Suspense } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Resources from "./Pages/Resources";
import Navbar from "./components/Navbar/Navbar";
import Home from "./Pages/Home";
import LeaderShipScreen from "./Pages/LeaderShipScreen";
import { motion } from "framer-motion";
import BeLaunchified from "./Pages/BeLaunchified";
import Certifications from "./Pages/Certifications";
import AimEngageGrow from "./components/AimEngageGrow/AimEngageGrow";
import ScrollToTop from "./components/ScrollToTop";
import Badge from "./components/Badge/Badge";

const pageVariants = {
  initial: { y: "-100vh", opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: "100vh", opacity: 0, transition: { duration: 0.4 } },
};

function App() {
  return (
    <Suspense
      fallback={
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      }
    >
      <Router>
        <ScrollToTop />
        <motion.div
          initial="initial"
          animate="animate"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.4 }}
          style={{ minHeight: "100vh", overflow: "hidden" }}
        >
          <Navbar />
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/leadership" component={LeaderShipScreen} />
            <Route path="/resources" component={Resources} />
            <Route path="/belaunchified" component={BeLaunchified} />
            <Route path="/certifications" component={Certifications} />
            <Route path="/aimgrowengage" component={AimEngageGrow} />
            <Route path="/badge" component={Badge} />
          </Switch>
          <Footer />
        </motion.div>
      </Router>
    </Suspense>
  );
}

export default App;
